<template>
  <div class="new">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <div>
      <div
        class="main-content1 pc"
      >
        <div style="background: #fff; padding: 20px">
          <div style="width: 100%; line-height: 30px; margin-top: 40px">
            <div class="big-title">
              <div class="big-name" style="">
                <span class="txt" style="font-size: 32px; font-weight: bold">{{
                  detail.title
                }}</span>
              </div>
            </div>
          </div>
          <div style="padding: 30px 0">{{ detail.abstract }}</div>
          <video width="100%" height="600" controls>
            <source :src="detail.file" type="video/mp4" />
          </video>
        </div>
      </div>
      <div
        class="main-content1 mobile"
      >
        <div style="background: #fff; padding: 0.2rem">
          <div style="width: 100%; line-height: 20px; margin-top: 0.2rem">
            <div class="big-title">
              <div class="big-name" style="">
                <span class="txt" style="font-size: 0.18rem; font-weight: bold">{{
                  detail.title
                }}</span>
              </div>
            </div>
          </div>
          <div style="padding: 0.1rem 0">{{ detail.abstract }}</div>
          <video width="100%" height="100%" controls :poster="detail.cover_images">
            <source :src="detail.file" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail, videodetail } from "@/api/common";
export default {
  name: "new",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "news",
      info: { carousel: "", Mcarousel: "" },
      loading: false,
      showDialog: false,
      detail: null,
    };
  },
  mounted() {
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    this.loading = true;
    videodetail({ id: this.$route.query.id }).then((res) => {
      this.loading = false;
      this.detail = res.data;
    });
  },
  methods: {
    handleSelect() {
      console.log(this.activeIndex);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-content1{
  padding-top: 50px; padding-bottom: 50px
}
@media screen and (max-width: 750px) {
  
.main-content1{
  padding-top: 0; padding-bottom: 0
}
}
</style>



// WEBPACK FOOTER //
// src/views/news/videoDetail.vue